var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input", {
            attrs: {
              type: _vm.type,
              autosize: { minRows: 2, maxRows: 10 },
              resize: "none",
              readonly: _vm.readonly,
              placeholder: _vm.placeholder,
              "data-bot": _vm.dataBot,
              size: _vm.size
            },
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.currentValue) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }